// Probability Forecast Widget (binary MVP)
// Captures the analyst's probability that the stock RISES after the print —
// P(up). After the event resolves, this is Brier-scored against the realized
// move to build a per-analyst calibration track record.

export interface ProbabilityForecastWidgetConfig {
  // Trading days after the print over which the move is measured at scoring time.
  resolutionWindow?: number;
}

export interface ProbabilityForecastWidgetInstanceConfig
  extends ProbabilityForecastWidgetConfig {
  dataKey: string;
}

// Dashboard data for a probability-forecast widget.
export interface ProbabilityForecastDataContent {
  probUp?: number;     // probability the stock is up after the print, 0..1
  rationale?: string;  // optional free-text justification
}

// Direction label for a given P(up). Shared by renderer, preview, and summary
// so the wording never drifts between them.
export function forecastDirectionLabel(probUp: number): string {
  if (probUp >= 0.66) return 'Likely up';
  if (probUp > 0.55) return 'Leaning up';
  if (probUp >= 0.45) return 'Toss-up';
  if (probUp > 0.34) return 'Leaning down';
  return 'Likely down';
}
